

import Vue from 'vue'
import App from './App'
import router from './router'
import common from './util/common'
import 'amfe-flexible';
import ToastPlugin from 'vux/src/plugins/toast/index.js'

Vue.config.productionTip = false
Vue.prototype.$common = common
Vue.use(ToastPlugin)

Vue.prototype.$showToast = (text, type, time, position) => {
Vue.$vux.toast.show({
text: text,
type: type || 'text',
time: time || 2000,
position: position || 'default'
});
};

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js